var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD80ProfileBlack = function SvgD80ProfileBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#27262A",
    cx: 40,
    cy: 40,
    r: 39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.91 0 0 17.908 0 40s17.91 40 40 40c22.093 0 40-17.908 40-40S62.093 0 40 0zm0 14.663c7.31 0 13.232 5.925 13.232 13.231 0 7.308-5.923 13.23-13.232 13.23-7.306 0-13.228-5.922-13.228-13.23 0-7.306 5.922-13.23 13.228-13.23zm-.009 54.879a29.355 29.355 0 0 1-19.116-7.05 5.638 5.638 0 0 1-1.978-4.285c0-7.41 5.996-13.34 13.407-13.34H47.7c7.413 0 13.387 5.93 13.387 13.34 0 1.648-.72 3.214-1.977 4.284a29.345 29.345 0 0 1-19.118 7.05z",
    fill: "#D8D5E0",
    fillRule: "nonzero"
  }))));
};
export default SvgD80ProfileBlack;